import { useState, useEffect } from 'react';

import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive';
import { expVal } from '@confluence/feature-experiments';

export const useForgePageBannerListener = () => {
	const [forgeAppsHeight, setForgeAppsHeight] = useState(getForgeAppsHeight());

	const isLivePage = useIsCurrentPageLive();

	const isForgePageBannerFixed = !isLivePage;

	useEffect(() => {
		const listener = (e) => {
			if (expVal('confluence_pgxp_p2m_batch_1', 'isEnabled', false)) {
				setForgeAppsHeight(e?.detail?.height ?? 0);
			} else {
				setForgeAppsHeight(getForgeAppsHeight());
			}
		};

		if (isForgePageBannerFixed) {
			document.addEventListener('forgePageBannerHeightUpdated', listener);
		}

		return () => {
			if (isForgePageBannerFixed) {
				document.removeEventListener('forgePageBannerHeightUpdated', listener);
			}
		};
	}, [isForgePageBannerFixed]);

	return {
		isForgePageBannerFixed,
		forgePageBannerHeight: forgeAppsHeight,
	};
};

const getForgeAppsHeight = () => {
	if (typeof document === 'undefined') {
		return 0;
	}

	return (
		parseInt(
			getComputedStyle(document.documentElement).getPropertyValue('--forge-page-banner-height'),
		) || 0
	);
};
